module.exports = __webpack_public_path__ + "img/san-jose-hotel-3.f504f06e.jpg";